<template>
  <div class="">
    <v-form ref="formRef">
      <v-combobox
        v-model="composeData.to"
        :items="contactArray"
        chips
        multiple
        deletable-chips
        hide-selected
        hide-details
        item-text="name"
        item-value="email"
        class="pt-0 px-2"
        flat
        :rules="[required]"
        prefix="To:"
        :return-object="true"
        @update:search-input="onSearch"
      >
        <!-- Slot: Prepend Inner -->
        <!-- <template #prepend-inner>
        <span class="text--primary font-weight-medium">To:</span>
      </template> -->
        <template #append>
          <span>&nbsp;</span>
        </template>
        <!-- Slot: Append Outer -->
        <template #append-outer>
          <v-btn icon small @click="showCcField"> Cc </v-btn>
          <v-btn icon small class="me-6 ms-1" @click="showBccField"> Bcc </v-btn>
        </template>
        <template v-slot:item="data">
          <v-list-item-title class="text-xs3">
            <div>{{ data.item.name }}</div>
            <div v-if="data.item.related_to" class="text-xs">
              {{ data.item.related_to.name }}
            </div>
          </v-list-item-title>
        </template>
        <template #selection="data">
          <v-chip v-if="data.item.name" close @click:close="remove(data.item, 'to')">
            {{ data.item.name }} - {{ data.item.email }}
          </v-chip>
          <v-chip v-else close @click:close="removeCustom(data.item, 'to')">{{ data.item }}</v-chip>
        </template>
      </v-combobox>
      <v-divider></v-divider>
      <!-- Field: CC -->
      <v-combobox
        v-show="shallShowCCFIeld"
        v-model="composeData.cc"
        :items="contactArray"
        solo
        flat
        chips
        multiple
        deletable-chips
        hide-selected
        hide-details
        item-text="name"
        item-value="email"
        class="pt-0"
        :return-object="true"
      >
        <!-- Slot: Option -->

        <!-- Slot: Prepend Inner -->
        <template #prepend-inner>
          <span class="text--primary font-weight-medium">Cc:</span>
        </template>

        <!-- Slot: Append -->
        <!-- append slot & `&nbsp;` to hide arrow on right -->
        <template #append>
          <span>&nbsp;</span>
        </template>
        <template v-slot:item="data">
          <v-list-item-title class="text-xs3">
            <div>{{ data.item.name }}</div>
            <div v-if="data.item.related_to" class="text-xs">
              {{ data.item.related_to.name }}
            </div>
          </v-list-item-title>
        </template>

        <template #selection="data">
          <v-chip v-if="data.item.name" close @click:close="remove(data.item, 'cc')">
            {{ data.item.name }} - {{ data.item.email }}
          </v-chip>
          <v-chip v-else close @click:close="removeCustom(data.item, 'cc')">{{ data.item }}</v-chip>
        </template>
      </v-combobox>

      <v-divider v-show="shallShowCCFIeld"></v-divider>

      <!-- Field: BCC -->
      <v-combobox
        v-show="shallShowBCCFIeld"
        v-model="composeData.bcc"
        :items="contactArray"
        solo
        flat
        chips
        multiple
        deletable-chips
        hide-selected
        hide-details
        item-text="name"
        item-value="email"
        class="pt-0"
        :return-object="true"
      >
        <!-- Slot: Prepend Inner -->
        <template #prepend-inner>
          <span class="text--primary">Bcc:</span>
        </template>
        <template v-slot:item="data">
          <v-list-item-title class="text-xs3">
            <div>{{ data.item.name }}</div>
            <div v-if="data.item.related_to" class="text-xs">
              {{ data.item.related_to.name }}
            </div>
          </v-list-item-title>
        </template>

        <!-- Slot: Append -->
        <!-- append slot & `&nbsp;` to hide arrow on right -->
        <template #append>
          <span>&nbsp;</span>
        </template>

        <template #selection="data">
          <v-chip v-if="data.item.name" close @click:close="remove(data.item, 'bcc')">
            {{ data.item.name }} - {{ data.item.email }}
          </v-chip>
          <v-chip v-else close @click:close="removeCustom(data.item, 'bcc')">{{
            data.item
          }}</v-chip>
        </template>
      </v-combobox>

      <v-divider v-show="shallShowBCCFIeld"></v-divider>

      <v-divider></v-divider>
      <v-text-field
        v-model="composeData.subject"
        class="px-2 pt-0"
        hide-details
        :rules="[required]"
        flat
        prefix="Subject:"
      >
        <!-- Slot: Prepend Inner -->
        <!-- <template #prefix>
        <span class="text--primary font-weight-medium">Subject:</span>
      </template> -->
      </v-text-field>
      <!-- Field: Message -->

      <vue-editor
        ref="quillEditor"
        v-model="composeData.message"
        class="quill-email"
        placeholder="Message"
        :editor-toolbar="customToolbar"
        use-custom-image-handler
        @image-added="handleImage"
      ></vue-editor>
      <v-row class="pa-2">
        <!-- <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2">{{ 'Contact' }}</label>
          <autocomplete-view
            v-if="isVisibleContactName"
            :label="defaultContactName"
            @handleClose="isVisibleContactName = false"
          />

          <v-autocomplete
            v-else
            v-model="composeData.contact_id"
            :items="contactArray"
            :search-input.sync="contactSearch"
            data-cy="log-contact"
            outlined
            dense
            autocomplete="null"
            item-text="name"
            item-value="uuid"
            class="custom-input"
            placeholder="Contact"
            @update:search-input="processContactInput"
          >
            <template v-slot:item="data">
              <v-list-item-title class="text-xs3">
                <div>{{ data.item.name }}</div>
                <div v-if="data.item.related_to" class="text-xs">
                  {{ data.item.related_to.name }}
                </div>
              </v-list-item-title>
            </template>
          </v-autocomplete>
        </v-col> -->
        <v-col cols="6" class="input-padding">
          <label class="text--primary text-xs2 required-mark">{{ 'Related To' }}</label>
          <autocomplete-view
            v-if="isVisibleName"
            :label="defaultPropName"
            @handleClose="isVisibleName = false"
          />
          <v-autocomplete
            v-else
            v-model="composeData.prop_id"
            :items="relatedToList"
            :search-input.sync="relatedToSearch"
            outlined
            dense
            :rules="[required]"
            autocomplete="null"
            item-text="name"
            item-value="uuid"
            class="custom-input"
            placeholder="Search..."
            @update:search-input="processInput"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <div class="px-2 py-2 attach-area">
        <span
          v-if="composeData.quote"
          class="attach-img d-inline-flex align-center position-relative mr-2"
        >
          Quote: {{ composeData.quote.name }}
        </span>
        <span
          v-for="item in attachments"
          :key="item.uuid"
          class="attach-img d-inline-flex align-center position-relative mr-2"
        >
          <img
            :src="require('@/assets/images/svg/folder-open1.svg')"
            class="mr-1"
            height="21px"
            width="19px"
          />
          <span class="text-xs2 text-truncate font-weight-semibold" style="color: #394d6b">{{
            item.name
          }}</span>

          <img
            class="ml-2 cursor-pointer"
            :src="require('@/assets/images/svg/close-circle.svg')"
            height="24"
            width="24"
            @click="deleteAttach(item.uuid)"
          />
        </span>
      </div>
      <div class="pa-3 pt-5">
        <v-btn
          color="primary"
          :disabled="imageLoading"
          class="mr-2"
          small
          :loading="loading"
          @click="send"
          >Send</v-btn
        >
        <v-menu
          top
          :offset-y="true"
          origin
          content-class="menu-component"
          attach
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark v-bind="attrs" v-on="on"> Signature </v-btn>
          </template>

          <v-list class="menu-list">
            <v-list-item
              v-for="(item, index) in signatureList"
              :key="index"
              link
              class="menu-list-item"
              @click="AddSignature(item)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-form>
  </div>
</template>

<script>
import { watch, ref, onMounted } from '@vue/composition-api'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import { ERROR_RESPONSE } from '@/constants/appConstants'
import Toaster from '@/@core/utils/sweetToast'
import { VueEditor } from 'vue2-editor'
import useFileUploader from '@core/utils/useFileUploader'
import { mdiClose, mdiImageOutline } from '@mdi/js'
import { required } from '@core/utils/validation'
import useDebounce from '@/plugins/useDebounce'
import AutocompleteView from '@/components/shared-components/AutocompleteView.vue'

export default {
  components: { VueEditor, AutocompleteView },
  props: {
    quoteEmailObj: {
      type: Object,
      default: () => {},
    },
    propType: {
      type: String,
      required: true,
    },
    propId: {
      type: String,
      default: undefined,
    },
    projectId: {
      type: String,
      default: undefined,
    },
    contactId: {
      type: String,
      default: undefined,
    },
    defaultContactName: {
      type: String,
      default: undefined,
    },
    defaultEmail: {
      type: String,
      default: undefined,
    },
    contactArray: {
      type: Array,
      default: () => [],
    },
    defaultPropName: {
      type: String,
      default: undefined,
    },
    relatedToList: {
      type: Array,
      default: () => [],
    },
    documentDirectory: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const { uploadStep1, uploadStep2, uploadStep3 } = useFileUploader()
    const { debounce } = useDebounce()

    const composeData = ref({
      to: [],
      bcc: [],
      cc: [],
      subject: null,
      message: '',
    })
    const loading = ref(false)
    const imageLoading = ref(false)
    const quillEditor = ref(null)
    const attachments = ref([])
    const signatureList = ref([])
    // Conditional Field Rendering
    const shallShowCCFIeld = ref(false)
    const shallShowBCCFIeld = ref(false)
    const formRef = ref(null)
    const contactSearch = ref('')
    const relatedToSearch = ref('')
    const isVisibleName = ref(false)
    const isVisibleContactName = ref(false)

    const setQuoteEmailObj = () => {
      // send quote email from quotelist
      if (props.quoteEmailObj && Object.keys(props.quoteEmailObj).length) {
        const bidder = props.contactArray.find(i => i.uuid === props.quoteEmailObj.bidder_id)
        if (bidder !== undefined) {
          composeData.value.to.push({
            email: bidder.email,
            name: bidder.name,
            phone: bidder.phone,
          })
        }
        composeData.value = { ...composeData.value, ...{ quote: props.quoteEmailObj.quote } }
      }
    }

    const processContactInput = () => {
      // emit event and fetch contact
      debounce(() => emit('fetchContacts', contactSearch.value), 800)
    }

    const processInput = () => {
      // emit event and fetch contact
      debounce(() => emit('fetchRelatedTo', relatedToSearch.value), 500)
    }

    onMounted(() => {
      setQuoteEmailObj()
    })

    watch(
      () => props.quoteEmailObj,
      value => {
        if (value) {
          setQuoteEmailObj()
        }
      },
    )

    watch(
      () => props.defaultPropName,
      val => {
        if (val) {
          isVisibleName.value = true
        }
      },
      { immediate: true },
    )

    watch(
      () => props.contactId,
      val => {
        if (val) {
          composeData.value = {
            ...composeData.value,
            to: [
              {
                name: props.defaultContactName,
                uuid: props.contactId,
                email: props.defaultEmail,
              },
            ],
          }
          isVisibleContactName.value = true
        }
      },
      { immediate: true },
    )

    const customToolbar = [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
    ]

    const loadSignature = () => {
      const payload = {
        component: 'setup/user-preferences',
        filter: {
          key: 'signatures',
        },
      }
      store.dispatch(`common/${storeActions.GET_ALL_RECORDS}`, payload).then(({ data }) => {
        if (data.success) {
          if (data.data && data.data.length) {
            signatureList.value = data.data[0].value
          }
        }
      })
    }

    loadSignature()

    const showCcField = () => {
      shallShowCCFIeld.value = !shallShowCCFIeld.value
      if (!shallShowCCFIeld.value) {
        composeData.value.cc = null
      }
    }

    const showBccField = () => {
      shallShowBCCFIeld.value = !shallShowBCCFIeld.value
      if (!shallShowBCCFIeld.value) {
        composeData.value.bcc = null
      }
    }

    const getCommaSeprated = item => {
      if (item && item.length) {
        console.log('[453] => items', item)
        const newItem = item.map(opt => {
          return opt.email
            ? { email: opt.email, name: opt.name, contact_id: opt.uuid }
            : { email: opt }
        })

        return newItem
      }

      return []
    }

    const setAttachmentFolder = async () => {
      try {
        const payLoad = {
          component: '/workdrive/attachments/folder',
          object: {
            subject: composeData.value.subject,
            prop_type: props.propType,
            prop_id: props.propId,
            attachments: attachments.value.map(opt => {
              return opt.uuid
            }),
          },
        }
        const { data } = await store.dispatch(`common/${storeActions.CREATE}`, payLoad)

        return data.data
      } catch (err) {
        Toaster.error('An eror occur, please try again later', 'warning')

        return false
      }
    }

    const send = async () => {
      const isValid = formRef.value.validate()
      if (!isValid) return

      const confirm =
        attachments.value.length &&
        (await Toaster.confirmation(
          'The attachment will be saved in a folder named this email subject.',
        ))
      loading.value = true
      if (confirm.isConfirmed) {
        const folderReference = await setAttachmentFolder()
        if (folderReference && folderReference.url) {
          composeData.value.message = [
            composeData.value.message,
            `<a href="${folderReference.url}">Attachment</a>`,
          ].join(' ')
        }
      }
      const payLoad = {
        component: 'email/send',
        object: {
          to: getCommaSeprated(composeData.value.to),
          cc: getCommaSeprated(composeData.value.cc),
          bcc: getCommaSeprated(composeData.value.bcc),
          subject: composeData.value.subject,
          message: composeData.value.message,
          prop_type: props.propType,
          prop_id: composeData.value.prop_id ? composeData.value.prop_id : props.propId,
          project_id: props.projectId,

          attachments: attachments.value.map(opt => {
            return opt.uuid
          }),
        },
      }

      if (props.quoteEmailObj && Object.keys(props.quoteEmailObj).length) {
        payLoad.object = { ...payLoad.object, ...{ quote: composeData.value.quote } }
      }
      store
        .dispatch(`common/${storeActions.CREATE}`, payLoad)
        .then(({ data }) => {
          loading.value = false
          emit('fetchRecord')
          attachments.value = []
          formRef.value.reset()
          // composeData.value = { to: [], subject: null, message: '', cc: [], bcc: [] }
          composeData.value.message = ''
          composeData.value.quote = null
          Toaster.success(data.message)
        })
        .catch(err => {
          if (err?.response.status === 400) {
            Toaster.error(err.response.data.message, 'warning')
          } else {
            Toaster.error(ERROR_RESPONSE, 'warning')
          }
          loading.value = false
        })
    }

    const AddSignature = value => {
      if (value.signatureType === 'draw') {
        const quill = quillEditor.value.quill
        const range = quill.getSelection()
        const position = range ? range.index : quill.getLength()
        quill.insertEmbed(position, 'image', value.signature)
      } else {
        composeData.value.message += value.signature
      }
    }

    const remove = (item, property) => {
      const index = composeData.value[property].findIndex(opt => {
        return item.uuid === opt.uuid
      })
      if (index >= 0) composeData.value[property].splice(index, 1)
    }
    const removeCustom = (item, property) => {
      const index = composeData.value[property].findIndex(opt => {
        return opt === item
      })

      if (index >= 0) composeData.value[property].splice(index, 1)
    }

    const onSearch = value => {
      debounce(() => emit('onInputSearch', value), 800)
    }

    const handleImage = async (file, Editor, cursorLocation, resetUploader) => {
      const payload = {
        object: {
          prop_id: props.propId,
          prop_type: props.propType,
          type: 1,
          parent_id: props.documentDirectory || 0,
          name: file.name,
        },
        component: 'workdrive/',
      }
      imageLoading.value = true
      const { data } = await uploadStep1(payload)
      if (data && data.data) {
        // upload to s3
        const object = {
          component: data.data.url,
          file,
        }
        const response = await uploadStep2(object)
        if (response) {
          const resp = await uploadStep3(data.data, true)
          if (resp.data && resp.data.success) {
            attachments.value.push({
              uuid: data.data.uuid,
              image: '',
              name: file.name,
            })
            resetUploader()
            imageLoading.value = false
          } else {
            imageLoading.value = false
            Toaster.error(ERROR_RESPONSE, 'warning')
          }
        } else {
          imageLoading.value = false
        }
      } else {
        imageLoading.value = false
        Toaster.error(ERROR_RESPONSE, 'warning')
      }
    }

    const deleteAttach = uuid => {
      attachments.value = attachments.value.filter(opt => {
        return opt.uuid !== uuid
      })
    }

    return {
      send,
      setAttachmentFolder,
      onSearch,
      AddSignature,
      setQuoteEmailObj,
      customToolbar,
      signatureList,
      composeData,
      loading,
      remove,
      removeCustom,
      showBccField,
      handleImage,
      attachments,
      deleteAttach,
      processContactInput,
      isVisibleContactName,
      isVisibleName,
      contactSearch,
      processInput,
      relatedToSearch,
      imageLoading,
      mdiImageOutline,
      quillEditor,
      // Conditional Field Rendering
      shallShowCCFIeld,
      showCcField,
      shallShowBCCFIeld,
      required,
      formRef,
      // icons

      mdiClose,
    }
  },
}
</script>

<style scoped lang="scss">
.attach-img {
  background: #dbe5ed;
  border-radius: 4px;
  padding: 8px 10px 8px 5px;
  font-size: 10px;
  max-width: 200px;
  img {
    border-radius: 4px;
  }
}

.delete-icon {
  border: 1.5px solid #1c6cab;
  border-radius: 50%;
}

.attach-area {
  border: 1px solid #ddd;
  border-top: 0;
}

::v-deep {
  .quill-email {
    .ql-toolbar.ql-snow + .ql-container.ql-snow {
    }
  }
}
</style>
